import { useEffect, useState } from 'react';

export const useAsyncError = () => {
  const [error, setError] = useState<Response | null>(null);

  useEffect(() => {
    if (error) {
      throw error;
    }
  }, [error]);

  return setError;
};
